import seongjaerokprofile from '../../static/images/profile/seongjaerok.png';

const members = [
    {
        name: "이사야",
        classOf: "20학번",
        blogURL: "",
        profileImage: ''
    },
    {
        name: "임다훈",
        classOf: "21학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "조윤주",
        classOf: "21학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "김대현",
        classOf: "20학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "안수빈",
        classOf: "23학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "김나경",
        classOf: "24학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "정보미",
        classOf: "21학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "이채원",
        classOf: "21학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "성재록",
        classOf: "20학번",
        blogURL: "https://m.blog.naver.com/PostList.naver?blogId=sjr_team, sungjaerok.blogspot.com",
        profileImage: ''
    },
    {
        name: "김대원",
        classOf: "20학번",
        blogURL: "https://dae-won.tistory.com/",
        profileImage: ''
    },
    {
        name: "송은지",
        classOf: "20학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "박인기",
        classOf: "20학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "송강규",
        classOf: "20학번",
        blogURL: "https://ggsong0328.github.io/",
        profileImage: ''
    },
    {
        name: "조수영",
        classOf: "20학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "정민규",
        classOf: "20학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "안혜련",
        classOf: "21학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "송가현",
        classOf: "21학번",
        blogURL: "https://github.com/SongGaHyeon",
        profileImage: ''
    },
    {
        name: "강도훈",
        classOf: "21학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "신예원",
        classOf: "22학번",
        blogURL: "https://blog.naver.com/rac8793",
        profileImage: ''
    },
    {
        name: "김시현",
        classOf: "21학번",
        blogURL: "https://k4sud0n.tistory.com",
        profileImage: ''
    },
    {
        name: "장태현",
        classOf: "21학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "전세은",
        classOf: "22학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "임초현",
        classOf: "22학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "김소정",
        classOf: "22학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "김하원",
        classOf: "23학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "백민서",
        classOf: "23학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "이소은",
        classOf: "23학번",
        blogURL: '',
        profileImage: ''
    },
    {
        name: "이동욱",
        classOf: '',
        blogURL: '',
        profileImage: ''
    }
];


export default members;
